import type { Components } from 'react-markdown';

export const markdownComponents: Components = {
  p: ({ node, ...props }) => (
    <p className="my-3 text-justify text-sm leading-6 text-slate-800" {...props} />
  ),
  h2: ({ node, ...props }) => (
    <h2 className="mb-1 mt-2 text-lg font-semibold text-slate-800" {...props} />
  ),
  h3: ({ node, ...props }) => (
    <h3 className="mb-1 mt-2 text-base font-semibold text-slate-800" {...props} />
  ),
  ul: ({ node, ...props }) => <ul className="my-3 list-disc space-y-2 pl-6" {...props} />,
  ol: ({ node, ...props }) => <ol className="my-3 list-decimal space-y-2 pl-6" {...props} />,
  li: ({ node, ...props }) => <li className="max-w-[90ch] pl-1.5 text-sm leading-6" {...props} />,
  a: ({ node, ...props }) => (
    <a
      className="mx-1 inline-block rounded-full bg-indigo-50 px-2 py-0 text-[0.7rem] text-neutral-400 hover:underline"
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    />
  ),
  strong: ({ node, ...props }) => <strong className="font-semibold" {...props} />,
  blockquote: ({ node, ...props }) => (
    <blockquote
      className="my-3 border-l-2 pl-4 italic"
      style={{ borderColor: '#EFF2FF', color: '#14203D' }}
      {...props}
    />
  ),
  hr: ({ node, ...props }) => (
    <div className="my-5 w-full">
      <hr
        className="relative -mx-6"
        style={{ borderColor: '#EFF2FF', width: 'calc(100% + 3rem)' }}
        {...props}
      />
      <div
        className="relative -mx-6 h-4"
        style={{
          width: 'calc(100% + 3rem)',
          background: 'linear-gradient(0deg, #FFFFFF 0%, rgba(244, 246, 253, 0.4) 100%)',
        }}
      />
    </div>
  ),
  table: ({ node, ...props }) => (
    <table className="my-4 w-full border-collapse text-sm" {...props} />
  ),
  thead: ({ node, ...props }) => <thead className="bg-slate-50" {...props} />,
  tbody: ({ node, ...props }) => <tbody {...props} />,
  tr: ({ node, ...props }) => <tr className="border-b last:border-b-0" {...props} />,
  th: ({ node, ...props }) => (
    <th className="border border-slate-200 px-3 py-2 text-left font-semibold" {...props} />
  ),
  td: ({ node, ...props }) => (
    <td className="border border-slate-200 px-3 py-2 align-top" {...props} />
  ),
};
